import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';

const LogoContainer = styled.div`
    span {
        position: absolute;
        top: 7px;
        font-family: Averta;
        font-weight: 700;
        font-size: 7px;
        text-transform: uppercase;
        letter-spacing: 1.5px;
        color: #ff245e;
    }

    svg {
        ${({ showPoweredBy }) =>
            !!showPoweredBy &&
            `
            position: absolute;
            top: 18px;
        `}
    }
`;

const ActionButtonLogo = props => (
    <LogoContainer showPoweredBy={props.showPoweredBy}>
        {props.showPoweredBy && <span>{'powered by'}</span>}
        <svg
            onClick={props.onClick}
            cursor="pointer"
            width={props.hideActionButtonText?"24":"90"}
            height="24"
            viewBox={props.hideActionButtonText?"0 0 159 159":"0 0 595 159"}
            xmlns="http://www.w3.org/2000/svg"
        >
            <title>Action Button</title>
            <g fill="none" fillRule="evenodd">
                {!props.hideActionButtonText && (<path
                    d="M226.04 48.9h-10.262l5.192-17.386 5.07 17.386zm-11.432-36.975l-19.64 54.993h15.212l2.045-6.44h17.434l2.045 6.44h15.445l-19.876-54.993h-12.666zM306.037 46.65c-1.542 5.313-6.29 8.613-12.396 8.613-8.74 0-15.083-6.662-15.083-15.84 0-7.873 5.13-15.843 14.932-15.843 6.78 0 11.518 3.78 12.674 10.108l.147.802h14.72l-.128-1.093c-1.61-13.658-12.688-22.835-27.565-22.835-8.79 0-16.273 3.042-21.637 8.797-4.902 5.26-7.602 12.384-7.602 20.062 0 14.342 10.095 28.86 29.39 28.86 14.126 0 25.17-8.512 27.482-21.183l.21-1.155h-14.938l-.205.706M355.216 66.918h14.232V24.49h12.047V11.925h-38.25V24.49h11.97v42.428M416.644 66.918h14.384V11.925h-14.384M479.24 39.422c0-7.68 5.1-15.842 14.553-15.842 9.453 0 14.554 8.162 14.554 15.842s-5.1 15.84-14.554 15.84c-9.453 0-14.553-8.16-14.553-15.84zm14.553 28.86c19.047 0 29.013-14.518 29.013-28.86 0-14.342-9.966-28.86-29.013-28.86-19.096 0-29.088 14.518-29.088 28.86 0 14.342 9.992 28.86 29.088 28.86zM580.192 11.925v31.748l-17.616-31.748h-14.358v54.993h14.23V35.595l17.542 31.323h14.357V11.925h-14.155M214.792 124.048h6.75c5.84 0 6.295 4.237 6.295 5.536 0 1.665-.62 5.537-6.372 5.537h-6.673V124.05zm0-10.973v-10.62h6.37c5.544 0 6.372 3.28 6.372 5.234 0 2.01-.828 5.385-6.37 5.385h-6.372zm20.35 5.567c3.524-1.822 6.623-5.517 6.623-11.483 0-3.68-1.31-15.68-18.177-15.68h-22.952v54.994h23.405c16.87 0 18.18-12.29 18.18-16.056 0-6.208-3.42-9.995-7.078-11.776zM301.205 127.312c0 4.24-3.93 7.962-8.41 7.962-4.52 0-8.336-3.647-8.336-7.962v-35.83h-14.23v35.905c0 11.66 9.7 20.45 22.564 20.45 12.91 0 22.643-8.79 22.643-20.45V91.48h-14.232v35.832M343.26 104.045h11.972v42.43h14.232v-42.43h12.047V91.48h-38.25v12.565M404.45 104.045h11.97v42.43h14.23v-42.43H442.7V91.48h-38.25v12.565M508.535 118.978c0 7.68-5.1 15.842-14.554 15.842-9.452 0-14.552-8.162-14.552-15.842s5.1-15.842 14.553-15.842c9.454 0 14.555 8.162 14.555 15.842zm-14.554-28.86c-19.096 0-29.087 14.52-29.087 28.86 0 14.342 9.99 28.86 29.088 28.86 19.047 0 29.012-14.518 29.012-28.86 0-14.34-9.965-28.86-29.01-28.86zM579.16 123.23l-17.614-31.75h-14.36v54.994h14.232V115.15l17.543 31.324h14.356V91.48H579.16v31.75"
                    fill="#000000"
                />)}
                <g fill="#FC2A61">
                    <path d="M57.64 155.413c6.827 1.932 14.04 2.95 21.484 2.95 43.703 0 79.13-35.426 79.13-79.123 0-29.382-16.01-55.023-39.783-68.67-4.166-2.394-8.933-1.2-10.65 4.213-1.718 5.41-15.547 52.088-15.547 52.088h32.693s-69.38 76.998-72.61 80.944c-2.944 3.595-7.205 3.46-7.205 3.46s9.58 3.312 12.49 4.14" />
                    <path d="M.016 79.24c0 29.376 16.01 55.017 39.782 68.666 4.167 2.398 8.936 1.2 10.654-4.21 1.717-5.413 15.544-52.09 15.544-52.09h-32.71s67.31-74.794 70.458-78.616c4.583-5.566 7.764-5.376 7.764-5.376S106.74 4.78 100.615 3.06C93.78 1.15 86.575.11 79.13.11 35.425.108 0 35.536 0 79.24h.016" />
                </g>
            </g>
        </svg>
    </LogoContainer>
);

ActionButtonLogo.propTypes = {
    onClick: PropTypes.func,
    showPoweredBy: PropTypes.bool,
    hideActionButtonText: PropTypes.bool  
};

export default ActionButtonLogo;
